<!-- Normal view -->
@if (sheets().sheets && sheets().sheets!.length > 0 && !fullscreen()) {
  <div class="relative flex h-full w-full flex-col">
    <!-- Header con navigazione fogli -->
    <div class="flex flex-row justify-between">
      @if (hasMultipleSheets()) {
        <div class="flex flex-shrink-0 items-center gap-2">
          <button
            mat-icon-button
            [disabled]="!hasPreviousSheet()"
            (click)="previousSheet()"
            aria-label="Foglio precedente"
          >
            <mat-icon>chevron_left</mat-icon>
          </button>

          <button mat-icon-button [disabled]="!hasNextSheet()" (click)="nextSheet()" aria-label="Foglio successivo">
            <mat-icon>chevron_right</mat-icon>
          </button>
          <span class="text-sm font-medium">{{ currentSheetName() }}</span>
          <span class="text-xs text-gray-500"> ({{ currentSheetIndex() + 1 }} di {{ sheets().sheets?.length }}) </span>
        </div>
      } @else {
        <div></div>
      }
      <ng-container *ngTemplateOutlet="actionsTemplate() || null"></ng-container>
    </div>

    <!-- Excel Content Area -->
    <div class="min-h-0 flex-1 overflow-auto p-2" (wheel)="onWheel($event)">
      <div
        [innerHTML]="currentSheetHtml() | safeHtml"
        [style.zoom]="zoomLevel()"
        [style.transform]="'scale(' + zoomLevel() + ')'"
        [style.transform-origin]="'top left'"
      ></div>
    </div>

    <!-- Zoom Controls -->
    <div
      class="absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-3 rounded-3xl bg-[var(--mat-sys-surface-container-highest)]/70 px-4 py-2 shadow-md sm:bottom-15 sm:gap-2 sm:px-3 sm:py-1.5 dark:bg-[var(--mat-sys-surface-container-lowest)]"
    >
      <button
        mat-icon-button
        class="h-8 w-8 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-40 sm:h-7 sm:w-7"
        (click)="zoomOut()"
        [disabled]="zoomLevel() <= 0.5"
        aria-label="Zoom out"
      >
        <mat-icon class="text-[20px]">zoom_out</mat-icon>
      </button>

      <span class="min-w-[50px] text-center text-sm font-medium sm:min-w-[40px] sm:text-xs"
        >{{ zoomLevel() * 100 | number: '1.0-0' }}%</span
      >

      <button
        mat-icon-button
        class="h-8 w-8 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-40 sm:h-7 sm:w-7"
        (click)="zoomIn()"
        [disabled]="zoomLevel() >= 3"
        aria-label="Zoom in"
      >
        <mat-icon class="text-[20px]">zoom_in</mat-icon>
      </button>

      <button
        mat-icon-button
        class="h-8 w-8 transition-colors duration-200 sm:h-7 sm:w-7"
        (click)="resetZoom()"
        aria-label="Reset zoom"
      >
        <mat-icon class="text-[20px]">refresh</mat-icon>
      </button>
    </div>
  </div>
}

<!-- Fullscreen Overlay -->
@if (sheets().sheets && sheets().sheets!.length > 0 && fullscreen()) {
  <div class="fixed inset-0 z-[9999] flex items-center justify-center" (click)="closeGallery()">
    <!-- Backdrop con blur -->
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

    <!-- Popup container con sfondo di sistema -->
    <div
      class="surface relative z-10 flex h-[85vh] w-[90vw] flex-col overflow-hidden rounded-xl shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <!-- Header con bottone close -->
      <div class="flex items-center justify-between p-2">
        <!-- Sheet Navigation -->
        @if (hasMultipleSheets()) {
          <div class="flex items-center gap-2">
            <button
              mat-icon-button
              [disabled]="!hasPreviousSheet()"
              (click)="previousSheet()"
              aria-label="Foglio precedente"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>

            <button mat-icon-button [disabled]="!hasNextSheet()" (click)="nextSheet()" aria-label="Foglio successivo">
              <mat-icon>chevron_right</mat-icon>
            </button>
            <span class="text-sm font-medium">{{ currentSheetName() }}</span>
            <span class="text-xs text-gray-500">
              ({{ currentSheetIndex() + 1 }} di {{ sheets().sheets?.length }})
            </span>
          </div>
        } @else {
          <div></div>
        }

        <!-- Action buttons -->
        <div class="flex items-center gap-2">
          <ng-container *ngTemplateOutlet="actionsTemplate() || null"></ng-container>
        </div>
      </div>

      <!-- Excel Content Area -->
      <div class="relative flex-1 overflow-hidden p-4">
        <div class="h-full w-full overflow-auto" (wheel)="onWheel($event)">
          <div
            [innerHTML]="currentSheetHtml() | safeHtml"
            [style.zoom]="zoomLevel()"
            [style.transform]="'scale(' + zoomLevel() + ')'"
            [style.transform-origin]="'top left'"
          ></div>
        </div>

        <!-- Zoom Controls -->
        <div
          class="absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-3 rounded-3xl bg-[var(--mat-sys-surface-container-highest)]/70 px-4 py-2 shadow-md sm:bottom-15 sm:gap-2 sm:px-3 sm:py-1.5 dark:bg-[var(--mat-sys-surface-container-lowest)]"
        >
          <button
            mat-icon-button
            class="h-8 w-8 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-40 sm:h-7 sm:w-7"
            (click)="zoomOut()"
            [disabled]="zoomLevel() <= 0.5"
            aria-label="Zoom out"
          >
            <mat-icon class="text-[20px]">zoom_out</mat-icon>
          </button>

          <span class="min-w-[50px] text-center text-sm font-medium sm:min-w-[40px] sm:text-xs"
            >{{ zoomLevel() * 100 | number: '1.0-0' }}%</span
          >

          <button
            mat-icon-button
            class="h-8 w-8 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-40 sm:h-7 sm:w-7"
            (click)="zoomIn()"
            [disabled]="zoomLevel() >= 3"
            aria-label="Zoom in"
          >
            <mat-icon class="text-[20px]">zoom_in</mat-icon>
          </button>

          <button
            mat-icon-button
            class="h-8 w-8 transition-colors duration-200 sm:h-7 sm:w-7"
            (click)="resetZoom()"
            aria-label="Reset zoom"
          >
            <mat-icon class="text-[20px]">refresh</mat-icon>
          </button>
        </div>
      </div>

      <!-- Sheet Tabs (se ci sono piu fogli) -->
      @if (hasMultipleSheets()) {
        <div
          class="flex gap-2 overflow-x-auto border-t border-solid border-[var(--mat-sys-outline)] bg-[var(--mat-sys-surface-container)] p-3"
        >
          @for (sheet of sheets().sheets; track $index) {
            <button
              class="sheet-tab flex-shrink-0 rounded-md px-4 py-2 text-sm font-medium transition-all"
              [class.sheet-tab-active]="currentSheetIndex() === $index"
              [class.sheet-tab-inactive]="currentSheetIndex() !== $index"
              (click)="goToSheet($index)"
            >
              {{ sheet.name || 'Foglio ' + ($index + 1) }}
            </button>
          }
        </div>
      }
    </div>
  </div>
}
